// extracted by mini-css-extract-plugin
module.exports = {"root":"LeftSidebar_root__2Uqr_","text":"LeftSidebar_text__1VnUm","btn":"LeftSidebar_btn__1c998","backIcon":"LeftSidebar_backIcon__2eQdE"};